<script setup>
    import dangerImage from '@/../images/landkit/illustrations/illustration-1.png';
    import successImage from '@/../images/landkit/illustrations/illustration-8.png';
    import infoImage from '@/../images/landkit/illustrations/illustration-2.png';

    const props = defineProps({
        type: { type: String, default: 'info' },
        id: String,
        title: String,
        message: String
    });
</script>

<template>
    <!-- Warning Alert Modal -->
    <div
        :id="id ?? ''"
        class="modal fade"
        tabindex="-1"
        role="dialog"
        aria-hidden="true"
        aria-modal="true">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
                <div class="modal-body p-4">
                    <div class="text-center">
                        <img
                            v-if="['warning', 'danger'].indexOf(type) >= 0"
                            :src="dangerImage"
                            alt="Error"
                            class="img-fluid mb-3"
                            style="width: 200px" />
                        <img
                            v-if="type === 'success'"
                            :src="successImage"
                            alt="Success"
                            class="img-fluid mb-3"
                            style="width: 200px" />
                        <img
                            v-if="type === 'info'"
                            :src="infoImage"
                            alt="Info"
                            class="img-fluid mb-3"
                            style="width: 200px" />
                        <h2 :id="`${id}-title`" class="mt-2 fw-bold">{{ title }}</h2>
                        <div :id="`${id}-body`">
                            <slot>
                                <p v-if="!message.startsWith('<')" v-html="message" />
                                <div v-else v-html="message" />
                            </slot>
                        </div>
                        <button
                            type="button"
                            class="btn my-2"
                            :class="{
                                'btn-primary': type === 'success',
                                'btn-danger': type === 'danger',
                                'btn-info': type === 'info',
                                'btn-warning':
                                    type !== 'success' && type !== 'danger' && type !== 'info'
                            }"
                            data-bs-dismiss="modal">
                            Continue
                        </button>
                    </div>
                </div>
            </div>
            <!-- /.modal-content -->
        </div>
        <!-- /.modal-dialog -->
    </div>
</template>

<script>
    export default {
        name: 'AlertModal'
    };
</script>

<style scoped></style>
